import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  skeleton: {
    height: '76px',
    width: '100%',
    borderRadius: '8px',
    marginBottom: theme.spacing(2), // Add spacing between skeletons
  },
}));

const TOCSearchLoading: React.FC = () => {
  const classes = useStyles();

  return (
    <div>
      <Skeleton variant="rect" className={classes.skeleton} />
      <Skeleton variant="rect" className={classes.skeleton} />
      <Skeleton variant="rect" className={classes.skeleton} />
    </div>
  );
};

export default TOCSearchLoading;
